import { useAtom } from 'jotai'

import { listFilterAtom } from '../store/list'

export const useExports = () => {
	const [listFilter, listFilterSet] = useAtom(listFilterAtom)

	return {
		listFilter,
		listFilterSet,
	}
}